import * as Yup from "yup";

// Define the validation schema
export const addValidationSchema = Yup.object().shape({
  district: Yup.string().required("District name is required"),
  talukas: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Taluka name is required"),
      })
    )
    .min(1, "At least one taluka is required"),
});
